import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FAILURE_TYPES, FAILURE_NAMES } from '../validationConstants';
var ERROR_OBJECT = {
  name: FAILURE_NAMES.required,
  type: FAILURE_TYPES.ERROR,
  hideBeforeSubmit: true,
  hideIfTouched: true
};

/**
 * Returns an error object if a field's config states that the field is required, but the field does not have a value.
 * Otherwise, returns null.
 */
export default (function (fieldValue, validationConfig) {
  return validationConfig.required && !fieldValue ? _objectSpread(_objectSpread({}, ERROR_OBJECT), {}, {
    fieldName: validationConfig.name
  }) : null;
});